import React from 'react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
export function Close() {
  return <section className="grid-dark w-full border-y-4 border-ember bg-forest-deep" data-id="element-44" data-mp="1zyh2w7skw2x2">
      <div className="mx-auto max-w-3xl px-5 py-14 text-center sm:py-20" data-id="element-45" data-mp="1uxjq6aqc812y">
        <h2 className="rule-underline font-display text-[36px] uppercase leading-tight text-paper sm:text-6xl" data-id="element-46" data-mp="1pz8cfowx96fg">
          Stop swapping parts.{' '}
          <span className="text-ember" data-id="element-47" data-mp="1l0yghc3di1ss">Split the cycle first.</span>
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-base text-paper/80" data-id="element-48" data-mp="1g96tfbjfee7e">
          Every ice machine call, from the first 15 minutes to the signed
          report — on cube, nugget and flake machines, with the paperwork
          already done.
        </p>

        <div className="mt-7" data-id="element-49" data-mp="176xi4jgc2gsy">
          <Countdown size="sm" tone="dark" data-id="element-50" data-mp="12a7564zts1br" />
        </div>

        <div className="mx-auto mt-6 flex max-w-lg flex-wrap items-center justify-between gap-3 rounded-2xl border border-ember bg-ember/10 px-5 py-4 text-left" data-id="element-51" data-mp="12bs03vq1xma5">
          <div data-id="element-52" data-mp="3ven39wzp7icp">
            <span className="block text-[10px] font-bold uppercase tracking-widest text-ember" data-id="element-53" data-mp="3ve3vva7occcx">
              Complete package
            </span>
            <span className="text-[15px] font-bold text-paper" data-id="element-54" data-mp="3lhhckpuzxtd0">
              Ice Machine Diagnostic Pro — 6 Volumes + 5 Bonuses
            </span>
          </div>
          <div className="flex items-baseline gap-2.5" data-id="element-55" data-mp="3qe7qp7n8qevs">
            <span className="text-[15px] text-paper/60 line-through" data-id="element-56" data-mp="i08t61kmelg6">$69</span>
            <span className="font-display text-5xl leading-none text-paper" data-id="element-57" data-mp="mzbubaxhc7iv">
              $27
            </span>
          </div>
        </div>

        <div className="mx-auto mt-5 max-w-lg" data-id="element-58" data-mp="81t40455lm9b">
          <CtaButton data-id="element-59" data-mp="d15polkagnab">Yes, I want the field system — $27</CtaButton>
        </div>

        <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-paper/65" data-id="element-60" data-mp="d38s652mo8vx">
          {['Secure checkout', 'Instant access', '7-day guarantee'].map(item => <li key={item} className="flex items-center gap-2" data-id="element-61" data-mp="2xpab5caeyw6q">
                <span className="h-1.5 w-1.5 rounded-full bg-ember" data-id="element-62" data-mp="148edbzmkib9j" />
                {item}
              </li>)}
        </ul>
      </div>
    </section>;
}